import React, { useState, useRef } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { RECAPTCHA_KEY } from '../util/constants';
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from 'react-i18next';
import ApiClient from "../services/api-client"
import { toast } from 'react-toastify';
import LoginRegisterLayout from '../components/layout/login-register-layout';
import '../styles/register.css';

function ResetPasswordForm() {
    const recaptchaRef = useRef();
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [repassword, setRepassword] = useState("");
    const { t } = useTranslation();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === "password") setPassword(value);
        if (name === "repassword") setRepassword(value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const recaptchaValue = recaptchaRef.current.getValue();

        if (repassword !== password) {
            toast.error(t("repassNotEqualPass"));
            return;
        }

        ApiClient.changePassword({ password, captcha: recaptchaValue, token }).then(
            (response) => {
                const data = response.data;
                if (data.status === "SUCCESS") {
                    toast.success(t("passwordResetSuccess"));
                    navigate("/login");
                } else if (data.errors?.length > 0) {
                    toast.error(data.errors[0].message);
                }
            },
            (error) => {
                const msg = error.response?.data?.message || error.message || error.toString();
                toast.error(msg);
            }
        );
    }

    const onChangeCaptcha = (value) => {
        const btn = document.getElementById("resetBtn");
        if (value) btn.removeAttribute("disabled");
        else btn.setAttribute("disabled", "disabled");
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="login-form-item">
                <input type="password" name="password"
                    className="form-control" placeholder={t("Password")}
                    value={password} onChange={handleInputChange} minLength={6} required />
            </div>
            <div className="login-form-item">
                <input type="password" name="repassword"
                    className="form-control" placeholder={t("rePassword")}
                    value={repassword} onChange={handleInputChange} minLength={6} required />
            </div>
            <div className="form-item text-center recapctha-container">
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={RECAPTCHA_KEY}
                    onChange={onChangeCaptcha}
                />
            </div>
            <hr />
            <div className="form-item">
                <button type="submit" disabled id="resetBtn" className="btn btn-block btn-skin">
                    {t("Reset")}
                </button>
            </div>
        </form>
    );
}

export default function ResetPassword(props) {
    if (props.authenticated) {
        return <Navigate to={{ pathname: "/" }} />;
    }

    return (
        <LoginRegisterLayout>
            <ResetPasswordForm />
        </LoginRegisterLayout>
    );
}
